import React, { FC, useEffect } from 'react'
import imgSrc from '../../assets/errors/401.svg'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { Text } from './styled'
import { history } from '../../store'
import { PAGE_LOGIN } from '../../constants/navigation'
import { resetStoreAction } from '../../store/actions'
import { useAppDispatch } from '../../hooks/useAppDispatch'

const Error401: FC = () => {
	const dispatch = useAppDispatch()

	useEffect(() => {
		dispatch(resetStoreAction())
	}, [dispatch])

	const handleClick = (): void => {
		history.replace(PAGE_LOGIN)
	}

	return (
		<Box
			display={'flex'}
			flexDirection={'column'}
			alignItems={'center'}
			maxWidth={'30rem'}
			minWidth={'14.5rem'}
		>
			<img src={imgSrc} alt={''} loading={'lazy'} width={225} />

			<Text paragraph mt={5.5} mb={2.8}>
				Sorry, this page is off limits to unauthorized users.
			</Text>

			<Button
				size={'large'}
				variant='contained'
				color={'primary'}
				sx={{ maxWidth: '9.31rem' }}
				onClick={handleClick}
			>
				Login
			</Button>
		</Box>
	)
}

export default Error401
